import { render, staticRenderFns } from "./UserTodoCard.vue?vue&type=template&id=70829190&scoped=true&"
import script from "./UserTodoCard.vue?vue&type=script&lang=js&"
export * from "./UserTodoCard.vue?vue&type=script&lang=js&"
import style0 from "./UserTodoCard.vue?vue&type=style&index=0&id=70829190&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70829190",
  null
  
)

export default component.exports